/* HERD — vanilla port of the Claude Design PDP logic, wired to Shopify's AJAX cart. */
(function () {
  'use strict';
  var H = window.HERD || { variants: {}, currency: '$' };

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  /* ---------- drawer + cart panel open/close ---------- */
  var scrim = $('[data-scrim]');
  function setDrawer(open) {
    var d = $('[data-drawer]');
    if (d) d.setAttribute('data-open', open);
    syncScrim(open || cartOpen);
  }
  var cartOpen = false;
  function setCart(open) {
    cartOpen = open;
    var c = $('[data-cart]');
    if (c) c.setAttribute('data-open', open);
  }
  function syncScrim(show) {
    if (scrim) scrim.setAttribute('data-open', show);
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-action]');
    if (!t) return;
    var a = t.getAttribute('data-action');
    if (a === 'drawer-open') setDrawer(true);
    if (a === 'drawer-close') setDrawer(false);
    if (a === 'cart-open') { setCart(true); refreshCart(); }
    if (a === 'cart-close') setCart(false);
    if (a === 'scrim') { setDrawer(false); setCart(false); }
    if (a === 'top') window.scrollTo({ top: 0, behavior: 'smooth' });
    if (a === 'checkout') window.location.href = '/checkout';
    if (a === 'atc') addToCart();
  });

  /* ---------- gallery ---------- */
  var gallery = $('#herd-gallery');
  var slide = 0;
  function setDots(i) {
    slide = i;
    $$('[data-dot]').forEach(function (d, idx) { d.setAttribute('data-active', idx === i); });
  }
  if (gallery) {
    gallery.addEventListener('scroll', function () {
      var i = Math.round(gallery.scrollLeft / gallery.clientWidth);
      if (i !== slide) setDots(i);
    }, { passive: true });
  }
  $$('[data-goslide]').forEach(function (b) {
    b.addEventListener('click', function () {
      var i = parseInt(b.getAttribute('data-goslide'), 10);
      if (gallery) gallery.scrollTo({ left: i * gallery.clientWidth, behavior: 'smooth' });
      setDots(i);
    });
  });

  /* ---------- chips (visual only) ---------- */
  $$('[data-chip]').forEach(function (c, i) {
    c.addEventListener('click', function () {
      $$('[data-chip]').forEach(function (x, j) { x.setAttribute('data-active', i === j); });
    });
  });

  /* ---------- FAQ ---------- */
  $$('[data-faq]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var n = btn.getAttribute('data-faq');
      var body = $('[data-faq-body="' + n + '"]');
      var open = body.getAttribute('data-open') === 'true';
      $$('[data-faq-body]').forEach(function (b) { b.setAttribute('data-open', 'false'); });
      $$('[data-chev]').forEach(function (c) { c.setAttribute('data-open', 'false'); });
      if (!open) {
        body.setAttribute('data-open', 'true');
        var chev = btn.querySelector('[data-chev]');
        if (chev) chev.setAttribute('data-open', 'true');
      }
    });
  });

  /* ---------- bundle picker ---------- */
  var bundle = 1; /* design default: 2-pack selected */
  function pickBundle(i) {
    bundle = i;
    $$('[data-bundle]').forEach(function (card, idx) {
      var on = idx === i;
      card.setAttribute('data-active', on);
      var r = card.querySelector('[data-radio]');
      if (r) r.setAttribute('data-active', on);
    });
    var card = $$('[data-bundle]')[i];
    if (!card) return;
    var v = H.variants[card.getAttribute('data-variant')];
    if (!v) return;
    var sp = $('#herd-sel-price'), sc = $('#herd-sel-compare');
    if (sp) sp.textContent = money(v.price);
    if (sc) sc.textContent = money(v.compare);
  }
  $$('[data-bundle]').forEach(function (card, i) {
    card.addEventListener('click', function () { pickBundle(i); });
  });
  pickBundle(bundle);

  /* ---------- sticky bar + scroll top ---------- */
  var cta = $('#herd-cta');
  function onScroll() {
    var sticky = false;
    if (cta) sticky = cta.getBoundingClientRect().bottom < 0;
    var st = $('[data-sticky]');
    if (st) st.setAttribute('data-visible', sticky);
    var tp = $('[data-totop]');
    if (tp) tp.setAttribute('data-visible', window.scrollY > 600);
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---------- countdown ---------- */
  var timerLeft = 99 * 60;
  var timerEl = $('#herd-timer');
  if (timerEl) {
    setInterval(function () {
      timerLeft = timerLeft > 0 ? timerLeft - 1 : 99 * 60;
      var h = Math.floor(timerLeft / 3600), m = Math.floor((timerLeft % 3600) / 60), s = timerLeft % 60;
      timerEl.textContent = [h, m, s].map(function (n) { return String(n).padStart(2, '0'); }).join(':');
    }, 1000);
  }

  /* ---------- Shopify AJAX cart ---------- */
  function addToCart() {
    var card = $$('[data-bundle]')[bundle];
    var id = card ? card.getAttribute('data-variant') : null;
    if (!id) return;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 })
    }).then(function (r) { return r.json(); }).then(function () {
      setCart(true);
      refreshCart();
    });
  }

  function changeLine(line, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function refreshCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart);
  }

  function renderCart(cart) {
    var wrap = $('#herd-lines');
    var tpl = $('#herd-line-tpl');
    if (!wrap || !tpl) return;
    wrap.innerHTML = '';
    var totalCompare = 0;
    var totalKits = 0;
    var firstPill = '';
    cart.items.forEach(function (item, idx) {
      var meta = H.variants[item.variant_id] || { units: 1, compare: item.original_price };
      var kits = (meta.units || 1) * item.quantity;
      totalKits += kits;
      var compare = (meta.compare || item.original_price) * item.quantity;
      totalCompare += compare;
      var pill = kits + ' Groundman LiftLink' + (kits > 1 ? 's' : '');
      if (!firstPill) firstPill = pill;
      var node = tpl.content.cloneNode(true);
      var img = node.querySelector('[data-l-img]');
      if (item.image) img.src = item.image; else img.removeAttribute('src');
      node.querySelector('[data-l-title]').textContent = (kits > 1 ? kits + 'x ' : '') + item.product_title;
      node.querySelector('[data-l-pill]').appendChild(document.createTextNode(' ' + pill));
      node.querySelector('[data-l-qty]').textContent = kits;
      node.querySelector('[data-l-compare]').textContent = money(compare);
      node.querySelector('[data-l-price]').textContent = money(item.final_line_price);
      node.querySelector('[data-l-save]').textContent = 'You save ' + money(Math.max(0, compare - item.final_line_price));
      var upsell = node.querySelector('[data-l-upsell]');
      if (upsell && meta.units === 1 && item.quantity === 1) upsell.style.display = 'inline-block';
      node.querySelector('[data-l-minus]').addEventListener('click', function () { changeLine(idx + 1, item.quantity - 1); });
      node.querySelector('[data-l-plus]').addEventListener('click', function () { changeLine(idx + 1, item.quantity + 1); });
      node.querySelector('[data-l-remove]').addEventListener('click', function () { changeLine(idx + 1, 0); });
      wrap.appendChild(node);
    });
    $$('[data-cart-count]').forEach(function (c) { c.textContent = totalKits; });
    var save = Math.max(0, totalCompare - cart.items_subtotal_price);
    var dl = $('#herd-disc-label'), da = $('#herd-disc-amt'), sub = $('#herd-subtotal'), cbtn = $('#herd-checkout-amt');
    if (dl) dl.textContent = firstPill || '—';
    if (da) da.textContent = '-' + money(save);
    if (sub) sub.textContent = money(cart.items_subtotal_price);
    if (cbtn) cbtn.textContent = money(cart.items_subtotal_price);
    var empty = $('#herd-cart-empty');
    if (empty) empty.style.display = cart.item_count === 0 ? 'block' : 'none';
    var summary = $('#herd-cart-summary');
    if (summary) summary.style.display = cart.item_count === 0 ? 'none' : 'flex';
  }

  /* ---------- demo video autoplay enforcement (webviews / battery-saver) ---------- */
  $$('video[autoplay]').forEach(function (v) {
    v.muted = true;               /* JS property, not just the attribute — some webviews require it */
    v.playsInline = true;
    v.setAttribute('webkit-playsinline', '');
    var kick = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
    kick();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) kick(); else v.pause();
        });
      }, { threshold: 0.25 }).observe(v);
    }
    document.addEventListener('touchstart', kick, { once: true, passive: true });
  });

  refreshCart();
})();
